import { Tag, Typography, List, Avatar } from "@douyinfe/semi-ui";
import { copy } from "../utils";
import {
  LoanStatusMap,
  OrderStatusMap,
  PaymentStatusMap,
  ProductStatusMap,
  UserInfoStatusMap,
  ClientLogStatusMap,
} from "../enums";
import { CrudOption } from "./crud";

export interface StatusProps {
  status: string;
}

export function TextCell(props: { text: string; width?: number }) {
  let themeMode = localStorage.getItem("theme-mode");
  let textColor = "rgba(var(--semi-text-0), 1)";
  if(themeMode == "dark"){
    textColor = "rgba(var(--semi-grey-9), 1)";
  }
  return (
    <Typography.Paragraph
      ellipsis={{
        rows: 1,
        showTooltip: {
          type: "popover",
          opts: { style: { maxWidth: 400, wordBreak: "break-all", color: textColor } },
        },
      }}
      style={{ width: props.width ? props.width : 200 }}
    >
      {props.text}
    </Typography.Paragraph>
  );
}

export function TextCellRemark(props: { moreText: string[]; width?: number; text?: string }) {
  let themeMode = localStorage.getItem("theme-mode");
  let textColor = "rgba(var(--semi-text-0), 1)";
  if(themeMode == "dark"){
    textColor = "rgba(var(--semi-grey-9), 1)";
  }
  let content = props.moreText instanceof Array ? getText(props.moreText) : "";
  let text = "";
  if (props.text) {
    text = props.text +
      "                                                            ";
  } else {
    text = props.moreText.length > 0
      ? props.moreText[props.moreText.length - 1].substring(20) +
      "                                                                                                "
      : "";
  }
  return (
    <Typography.Paragraph
      ellipsis={{
        rows: 1,
        showTooltip: {
          type: "popover",
          opts: {
            content: content,
            style: {
              width: 600,
              maxWidth: 600,
              wordBreak: "break-all",
              whiteSpace: "pre-wrap",
              color: textColor
            },
          },
        },
      }}
      style={{ width: props.width ? props.width : 200, whiteSpace: "pre" }}
    >
      {text}
    </Typography.Paragraph>
  );
}

export function TextCellLoanRemark(props: { moreText: string[]; width?: number; text?: string }) {
  let content = props.moreText instanceof Array ? getLoadArrText(props.moreText) : [];
  let text = "";
  if (props.text) {
    text = props.text +
      "                                                            ";
  } else {
    text = props.moreText.length > 0
      ? props.moreText[props.moreText.length - 1].substring(20) +
      "                                                                                                "
      : "";
  }
  return (
    <Typography.Paragraph
      ellipsis={{
        rows: 1,
        showTooltip: {
          type: "popover",
          opts: {
            content: () => {

              return (
                <List
                  dataSource={content}
                  renderItem={item => (
                    <List.Item
                      style={{ width: 500 }}
                      header={<Avatar size="small" style={{ padding: 4 }} color={item.index==0?"green":"blue"}>{item.userName}</Avatar>}
                      main={
                        <div>
                          <span style={{ color: 'var(--semi-color-text-0)', fontWeight: 500 }}>{item.dateStr}</span>
                          {item.content}
                        </div>
                      }

                    />
                  )}
                />
              );

            },
            style: {
              width: 500,
              maxWidth: 600,
              wordBreak: "break-all",
              whiteSpace: "pre-wrap",
            },
          },
        },
      }}
      style={{ width: props.width ? props.width : 200, whiteSpace: "pre" }}
    >
      {text}
    </Typography.Paragraph>
  );
}

const getLoadArrText = (vales: string[]) => {
  let retArr = [];
  let start = 0;
  let firstName = "";
  //只显示最新10条
  if (vales.length > 10) {
    start = vales.length - 10;
  } 
  for (let i = start; i < vales.length; i++) {
    let ele = vales[i];
    let dateStr = ele.substring(0,20);
    let userName = ele.substring(20,24).trim().replace(":","");
    let content = ele.substring(25);
    if(i==0){
        firstName = userName;
    }
    let data = {
      dateStr: dateStr,
      userName: userName,
      index:firstName == userName?0:1,
      content: <p style={{color: 'var(--semi-color-text-2)',
      margin: '4px 0',}}>
        {content}
      </p>
    }

    retArr.push(data)
  }

  return retArr;
};

const getText = (vales: string[]) => {
  let retStr = "";
  //只显示最新10条
  if (vales.length > 10) {
    for (let i = vales.length - 10; i < vales.length; i++) {
      let ele = vales[i];
      retStr = retStr + ele + "\r\n";
    }
  } else {
    vales.forEach((ele) => {
      retStr = retStr + ele + "\r\n";
    });
  }

  return retStr;
};

export function LoanStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = LoanStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"PAID" == props.status ? "green" : "white"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}

export function UserInfoStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = UserInfoStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"AUTHED" == props.status ? "green" : "white"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}

export function ProductStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = ProductStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"NORMAL" == props.status ? "green" : "red"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}

export function OrderStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = OrderStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"PAID" == props.status ? "green" : "white"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}

export function PaymentStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = PaymentStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"OK" == props.status ? "green" : "white"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}

export interface CopyLinkProps {
  link: string;
}

export function CopyLink(props: CopyLinkProps) {
  if (props.link) {
    return (
      <Typography.Text
        onClick={(e) => {
          copy(props.link);
          e.preventDefault();
        }}
        link={{ href: props.link }}
      >
        复制链接
      </Typography.Text>
    );
  } else {
    return null;
  }
}

export function toOptionList(enums: Record<string, string>): CrudOption[] {
  return Object.keys(enums)
    .sort()
    .map((k) => {
      return {
        value: k,
        label: enums[k],
        key: k,
      };
    });
}

export function ClientLogStatus(props: StatusProps) {
  if (!props.status) return null;
  const map: Record<string, string> = ClientLogStatusMap;
  const value = map[props.status];
  return (
    <Tag size="small" color={"OK" == props.status ? "green" : "white"}>
      {" "}
      {value ? value : props.status}{" "}
    </Tag>
  );
}
